export default __webpack_public_path__ + "static/media/home-popup2.0892de17.jpeg";